import { useEffect } from "react";
import Router from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

// import { getLinkFromTranslation, getLocaleFromContext } from "ab-functions";

import ABAccount from "ab-account";
import ABAccountDetails from "ab-account-details";
import { getPage } from "ab-api-queries";
import { getAuthToken } from "ab-functions-auth";

const Login = () => {
  const { i18n } = useTranslation("common");
  useEffect(() => {
    const authToken = getAuthToken();
    if (!authToken) {
      Router.push("/login");
    }
  }, []);

  return (
    <>
      <ABAccount i18n={i18n}>
        <ABAccountDetails i18n={i18n} />
      </ABAccount>
    </>
  );
};

export async function getServerSideProps({ locale }) {
  const data = await getPage("/mi-cuenta");
  // const locale = getLocaleFromContext(context);
  // const redirectURL = getLinkFromTranslation(data?.nodeByUri?.translations, locale);

  // if (locale != 'es' && redirectURL) {
  //   return {
  //     redirect: {
  //       permanent: false,
  //       destination: redirectURL
  //     }
  //   };
  // }

  const translations = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      footer: data?.headerFooter?.footer,
      menu: data?.headerFooter?.menu,
      translations: data?.nodeByUri?.translations,
      language: data?.nodeByUri?.language,
      ...translations,
    }, // will be passed to the page component as props
  };
}

export default Login;
